import React, { useEffect } from "react";
import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SwitchComponent from "../../components/switch/switch.component";
import SelectComponent from "../../components/select/select.component";
import TextareaComponent from "../../components/textarea/textarea.component";
import { useForm } from "react-hook-form";
import { to } from "../../polyfill";
import { LoanCreditsService } from "../../services/loan-credits";
import Button from "../../components/button/button.component";

function FormModal({ show, data, setShow }: any) {
  const defaultValues = {
    name: '',
    _id: '',
    account: '',
    status: true,
  }

  const { watch, setValue, reset, register, handleSubmit, formState: { errors, isSubmitting, isValid }, } = useForm<typeof defaultValues>({
    mode: 'onChange',
    defaultValues,
  });

  const submit = async(form: typeof defaultValues) => {
    const [error, data] = await to(LoanCreditsService.save(form.name, form._id, form.status));
    if(error) {
      alert(error.message)
    } else {
      setShow(true)
      reset(defaultValues);
    }
  }

  useEffect(() => {
    if(data) {
      setValue('name', data.name);
      setValue('_id', data._id);
      setValue('account', data.account);
      setValue('status', data.status);
    } else {
      reset(defaultValues);
    }
  }, [data])

  return (
    <Modal show={show}>
      <div className="modal-header">
      <h3 className="modal-title">{watch('_id') ? 'Editar': 'Agregar'} cuenta</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <InputComponent label="Nombre *" {...register('name', { required: true })} errors={errors.name}/>
        </div>

        {
          watch('_id') && <SwitchComponent label="Estatus" {...register('status')} errors={errors.status} />
        }
        
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FormModal;
